import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { DndModule } from "ngx-drag-drop";

import { ModalDialogService } from "./modals/modaldialog/modaldialog.service";
import { AdminAuthService } from "./services/adminauth.service";
import { UserAuthService } from "./services/userauth.service";
import { ExamService } from "./services/exam.service";
import { EventsHubService } from "./services/eventshub.service";
import { BrandService, loadBrand } from "./services/brand.service";

import { AppRouterModule } from "./router/approuter.module";

import { AppComponent } from "./app.component";

import { PageEditComponent } from "./pages/pageedit/pageedit.component";
import { PageEditLoginComponent } from "./pages/pageeditlogin/pageeditlogin.component";
import { PageEvaluateComponent } from "./pages/pageevaluate/pageevaluate.component";
import { PageEvaluateLoginComponent } from "./pages/pageevaluatelogin/pageevaluatelogin.component";
import { PageExamComponent } from "./pages/pageexam/pageexam.component";
import { PageLoginComponent } from "./pages/pagelogin/pagelogin.component";
import { PageViewComponent } from "./pages/pageview/pageview.component";
import { PageViewLoginComponent } from "./pages/pageviewlogin/pageviewlogin.component";

import { EditNameComponent } from "./modals/editname/editname.component";
import { AdminLoginComponent } from "./modals/adminlogin/adminlogin.component";
import { AdminLoginFormComponent } from "./components/adminloginform/adminloginform.component";
import { ExamPropertiesComponent } from "./modals/examproperties/examproperties.component";
import { ExamMenuEditComponent } from "./modals/exammenuedit/exammenuedit.component";
import { LibraryImagesComponent } from "./modals/libraryimages/libraryimages.component";
import { LibrarySoundsComponent } from "./modals/librarysounds/librarysounds.component";
import { LibraryVideosComponent } from "./modals/libraryvideos/libraryvideos.component";
import { ModalDialogComponent } from "./modals/modaldialog/modaldialog.component";

import { EditorComponent } from "./components/editor/editor.component";
import { EditorPagesListComponent } from "./components/editorpageslist/editorpageslist.component";
import { EditToolBarComponent } from "./components/edittoolbar/edittoolbar.component";
import { ExamComponent } from "./components/exam/exam.component";
import { ObjectsPropertiesComponent } from "./components/objectsproperties/objectsproperties.component";
import { ObjectsHierarchyComponent } from "./components/objectshierarchy/objectshierarchy.component";
import { ObjectsHierarchyMenuComponent } from "./components/objectshierarchymenu/objectshierarchymenu.component";
import { PageObjectButtonComponent } from "./components/pageobjectbutton/pageobjectbutton.component";
import { PageObjectContainerComponent } from "./components/pageobjectcontainer/pageobjectcontainer.component";
import { PageObjectEvaluationComponent } from "./components/pageobjectevaluation/pageobjectevaluation.component";
import { PageObjectImageComponent } from "./components/pageobjectimage/pageobjectimage.component";
import { PageObjectInputComponent } from "./components/pageobjectinput/pageobjectinput.component";
import { PageObjectSelectionComponent } from "./components/pageobjectselection/pageobjectselection.component";
import { PageObjectSoundComponent } from "./components/pageobjectsound/pageobjectsound.component";
import { PageObjectTextComponent } from "./components/pageobjecttext/pageobjecttext.component";
import { PageObjectLinkComponent } from "./components/pageobjectlink/pageobjectlink.component";
import { PageObjectListComponent } from "./components/pageobjectlist/pageobjectlist.component";
import { PageObjectUploadButtonComponent } from "./components/pageobjectuploadbutton/pageobjectuploadbutton.component";
import { PageObjectVideoComponent } from "./components/pageobjectvideo/pageobjectvideo.component";
import { PageObjectArrowComponent } from "./components/pageobjectarrow/pageobjectarrow.component";
import { PageUiComponent } from "./components/pageui/pageui.component";
import { SideBarComponent } from "./components/sidebar/sidebar.component";

import { FocusDirective } from "./directives/focus.directive";
import { FormControlErrorDirective } from "./directives/formcontrolerror.directive";
import { UploadButtonDirective } from "./directives/uploadbutton.directive";

import { ServerResourcesPathPipe } from "./pipe/serverresourcespath.pipe";

@NgModule({
  imports: [
    BrowserModule, //
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    DndModule,
    AppRouterModule,
  ],
  declarations: [
    AppComponent,

    PageEditComponent,
    PageEditLoginComponent,
    PageEvaluateComponent,
    PageEvaluateLoginComponent,
    PageExamComponent,
    PageLoginComponent,
    PageViewComponent,
    PageViewLoginComponent,

    EditNameComponent,
    AdminLoginComponent,
    AdminLoginFormComponent,
    ExamPropertiesComponent,
    ExamMenuEditComponent,
    LibraryImagesComponent,
    LibrarySoundsComponent,
    LibraryVideosComponent,
    ModalDialogComponent,

    EditorComponent,
    EditorPagesListComponent,
    EditToolBarComponent,
    ExamComponent,
    ObjectsPropertiesComponent,
    ObjectsHierarchyComponent,
    ObjectsHierarchyMenuComponent,
    PageObjectButtonComponent,
    PageObjectContainerComponent,
    PageObjectEvaluationComponent,
    PageObjectImageComponent,
    PageObjectInputComponent,
    PageObjectSelectionComponent,
    PageObjectSoundComponent,
    PageObjectTextComponent,
    PageObjectLinkComponent,
    PageObjectListComponent,
    PageObjectUploadButtonComponent,
    PageObjectVideoComponent,
    PageObjectArrowComponent,
    PageUiComponent,
    SideBarComponent,

    FocusDirective,
    FormControlErrorDirective,
    UploadButtonDirective,
    ServerResourcesPathPipe,
  ],
  entryComponents: [
    EditNameComponent,
    AdminLoginComponent,
    ExamPropertiesComponent,
    ExamMenuEditComponent,
    LibraryImagesComponent,
    LibrarySoundsComponent,
    LibraryVideosComponent,
    ModalDialogComponent,
  ],
  providers: [
    ModalDialogService,
    AdminAuthService,
    UserAuthService,
    ExamService,
    EventsHubService,
    ServerResourcesPathPipe,
    BrandService,
    { provide: APP_INITIALIZER, useFactory: loadBrand, deps: [BrandService], multi: true },
  ],
  bootstrap: [
    AppComponent, //
  ],
})
export class AppModule {}
